/* eslint-disable */

import Signup from "components/features/signup/Signup";

const SignupPage = () => {
  return <Signup />;
};

export default SignupPage;
